import { apiCall } from './api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Ask the gateway for a 10-minute, actor-bound link. Throws err.detail.code === 'grant_required'
// when the file is restricted and the caller must request access first.
export async function signFileUrl(path) {
  const data = await apiCall('/api/files/sign', { method: 'POST', body: JSON.stringify({ path }) });
  return { ...data, absolute: `${API_URL}${data.url}` };
}

export async function openSecureFile(path) {
  const win = window.open('', '_blank', 'noopener');
  try {
    const { absolute } = await signFileUrl(path);
    if (win) win.location.replace(absolute); else window.location.assign(absolute);
    return absolute;
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}

export function isGrantRequired(err) {
  return err?.detail?.code === 'grant_required' || /request access/i.test(err?.message || '');
}
